import type {SourceType} from 'nutshell-graphql-types';

export const getDisplayableType = (type: SourceType): string | null | undefined => {
    if (type === 'NONE') {
        return null;
    }

    return type.charAt(0) + type.slice(1).toLowerCase();
};

export const getReportUrl = (sourceId: string): string => {
    return `/leads?fields[leads]=name,createdTime,value,owner,milestone,confidence,closedTime,sources&sort=value&filter[sources]=${sourceId}&report[gap]=w&report[type]=createdTime&report[pivotFacet]=count&view=list`;
};
